<template>
	<div>
		<v-card>
			<v-toolbar color="cyan" dark flat>
			<v-toolbar-title>Admin page</v-toolbar-title>
			<v-spacer></v-spacer>

			<template v-slot:extension>
				<v-tabs
					v-model="tab"
					align-with-title
				>
				<v-tabs-slider color="yellow"></v-tabs-slider>

				<v-tab key="revenue"> Revenue </v-tab>
				<v-tab key="user"> User </v-tab>
				<v-tab key="registration"> Registration </v-tab>
				<v-tab key="installation"> Installation </v-tab>
				</v-tabs>
			</template>
			</v-toolbar>

			<v-tabs-items v-model="tab">

			<!-- revenue related actions -->
			<v-tab-item key="revenue">
				<v-autocomplete
					v-model="formState.selectedMandators"
					:items="formItems.mandator"
					hide-selected
					label="Mandator"
					solo
					persistent-hint
					chips
					return-object
				/>
				<v-toolbar dense>
					<template v-slot:extension>
						<v-tabs
							v-model="tabRevenue"
							align-with-title
						>
							<v-tabs-slider color="black"/>

							<v-tab key="S3ExportHealthCheck">S3 Export Health Check</v-tab>
							<v-tab key="PSQLImportHealthCheck">PSQL Import Health Check </v-tab>
							<v-tab key="manualCubeCreation">Create or Delete a Sales Cube</v-tab>
						</v-tabs>
					</template>
				</v-toolbar>
				<v-card>
					<v-tabs-items v-model="tabRevenue">
						<v-tab-item key="S3ExportHealthCheck">
							<admin-s-3-export-health-check v-bind:selectedMandators="formState.selectedMandators"/>
						</v-tab-item>
						<v-tab-item key="PSQLImportHealthCheck">
							<admin-import v-bind:selectedMandators="formState.selectedMandators"/>
						</v-tab-item>
						<v-tab-item key="manualCubeCreation">
							<admin-manual-import
								v-bind:selectedMandators="formState.selectedMandators"
								:loadingData = loadingData
								@salesCubeCreation="createSalesCube"
								@salesCubeDeletion="deleteSalesCube"
								@revenueItemDeletion="deleteRevenueItem"
							/>
						</v-tab-item>
					</v-tabs-items>
				</v-card>
			</v-tab-item>

			<!-- user related actions -->
			<v-tab-item key="user">
				<!-- create new user -->
				<v-card class="keycloakAdminSection">
					<admin-keycloak></admin-keycloak>
				</v-card>
			</v-tab-item>

			<v-tab-item key="registration">
				<!-- registration releated admin actions -->
				<v-card>
					<admin-registration-iso></admin-registration-iso>
				</v-card>
			</v-tab-item>

			<v-tab-item key="installation">
				<!-- installation settings -->
				<v-card>
					<installation/>
				</v-card>
			</v-tab-item>
			</v-tabs-items>
		</v-card>
	</div>
</template>

<script>
import AdminImport from "../adminPage/AdminImport.vue"
import AdminManualImport from "../adminPage/AdminManualImport.vue"
import AdminKeycloak from "./keycloak/AdminKeycloak.vue"
import AdminRegistrationIso from './AdminRegistrationIsoLoad.vue'
import Installation from './installation/installation.vue'
import AdminS3ExportHealthCheck from './AdminS3ExportHealthCheck.vue'
import axios from "axios"

export default {
	name: "admin",
	components: {
		AdminImport,
		AdminManualImport,
		AdminKeycloak,
		AdminRegistrationIso,
		Installation,
		AdminS3ExportHealthCheck,
	},
	data() {
		return {
			itemsTabs: [
				{ title: 'Dashboard', icon: 'mdi-view-dashboard' },
				{ title: 'Photos', icon: 'mdi-image' },
				{ title: 'About', icon: 'mdi-help-box' },
			],
			right: null,
			formState: {
				selectedMandators: [],
			},
			formItems: {
				mandator: ['Mandators could not be loaded'],
			},
			loaded: "",
			loadingData: false,
			tab: null,
			tabRevenue: null,
			items: ['revenue', 'users', 'registration', 'installation'],
		}
	},
	methods: {
		async getMandators() {
			try {
				this.isLoading = true
				const r = await axios.get(`${config.baseAPIurl}/revenue-report/mandator?appNameShort=rr`)
				this.$data.formItems.mandator = r.data
			} catch (error) {
				console.log(error)
			} finally {
				this.isLoading = false
			}
		},

		async createSalesCube(filterData) {
			let filterOptions = filterData;
			try {
				this.loadingData = true;
				await axios.post(config.baseAPIurl + "/admin-page/sales-cube", {
					filterOptionsSalesCube: filterOptions,
				})
			}
			catch (e) {

			}
			setTimeout(() => {
				this.loadingData = false;
			}, 1500);
		},

		async deleteSalesCube(filterData) {
			let filterOptions = filterData;
			try {
				this.loadingData = true;
				await axios.delete(config.baseAPIurl + "/admin-page/sales-cube", {
					data: {
						filterOptionsSalesCube: filterOptions,
					}
				}).then(res => {
					console.log("Sales Cube Deleted");
				}).finally(() => {
				})
			}
			catch (e) {

			}
			setTimeout(() => {
				this.loadingData = false;
			}, 1500);
		},

		async deleteRevenueItem(filterData) {
			try {
				this.loadingData = true
				await axios.delete(`${config.baseAPIurl}/admin-page/revenue-item`, {
					data: {
						filterOptionsRevenueItem: filterData,
					},
				})
			}
			catch (e) {

			}
			setTimeout(() => {
				this.loadingData = false;
			}, 1500);
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.getMandators()
		})
	},
}
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #64c823;
}

.manualImport {
  padding-top: 25px;
}

.checkImportHealth {
  padding-top: 25px;
}

.fixOrders {
  padding: 25px;
}

.keycloakAdminSection{
  padding: 0px !important;
  margin: 0px !important;
}

</style>
